module.exports = __webpack_public_path__ + "img/traffic.abec42cd.png";